export const LIFI = "lifi";
// export const DEEBRIDGE = "debridges";
export const SYMBIOISES = "symbiosis";
export const ONE_INCH = "1inch";
export const CHAINSPOT = "chainspot";
